export default __webpack_public_path__ + "static/media/tiger_logo_yellow.5b46e87b.png";